import { Component, ViewChild } from "@angular/core";
import { StepperComponent } from "../stepper/stepper/stepper.component";

@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    standalone: false
})
export class HeaderComponent {
  @ViewChild('stepper') stepper: StepperComponent;
}
